// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BkHKx","screen":"styles_screen__ksQpj","full":"styles_full__zv32B"};